import { render, staticRenderFns } from "./GDPRScreen.vue?vue&type=template&id=74b5c44e"
import script from "./GDPRScreen.vue?vue&type=script&lang=js"
export * from "./GDPRScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports